<template>
  <div class="lawyer">
    <div class="local red" v-if="type != ''">{{ type }}</div>
    <div class="photo-box">
      <img :src="getOrgPhotoURL(info.provider_id, info.cover)" />
    </div>
    <p class="title">{{ type }}法律服务中心</p>
    <p class="tel">联系电话：{{ post.phone }}</p>
    <p class="address">地址：{{ post.description }}</p>
    <div class="tag_box">
      <div class="ghost">
        <span>
          <router-link :to="`/orgDetails/${post.provider_id}`">查看详细</router-link>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import base from '@/core/base.js'
export default {
  name: 'lawcore',
  mixins: [base],
  data () {
    return {
      info: {}
    }
  }
}
</script>
